module.exports = __webpack_public_path__ + "f8ea83ca5c6e98361c2c763a51a90797.MP3";